import { render } from "./AdminLoadingAction.vue?vue&type=template&id=14e515f5&scoped=true"
const script = {}

import "./AdminLoadingAction.vue?vue&type=style&index=0&id=14e515f5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e515f5"]])

export default __exports__